
import {
    apiAiMenuList, apiAiMenuAdd, apiAiMenuEdit
} from "@/api/setting";
import { Component, Prop, Vue } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import LsDialog from "@/components/ls-dialog.vue";
import { RequestPaging } from "@/utils/util";
import DatePicker from "@/components/date-picker.vue";
import PromotCommon from "@/components/promot-common.vue";
@Component({
    components: {
        lsPagination,
        LsDialog,
        DatePicker, PromotCommon
    },
})
export default class SetMealList extends Vue {
    /** S Data **/

    apiAiMenuList = apiAiMenuList;

    pager: RequestPaging = new RequestPaging();

    searchObj: Object = {};
    id = 0;
    form: any = {
        zh_cn_title: "", //
        en_title: "", //
        icon: "", //
        status: 1,
        sort: 1,
    };
    formDialogVisible = false;

    /** E Data **/

    /** S Methods **/

    // 获取列表
    getLists(): void {
        this.pager.request({
            callback: apiAiMenuList,
            params: {
                ...this.searchObj,
            },
        });
    }

    handleAdd() {
        this.id = 0;
        this.form = {
            zh_cn_title: "",
            en_title: "",
            icon: "",
            status: 1,
            sort: 1,
            type: 0,
        };
        this.formDialogVisible = true;
    }
    // 点击编辑
    async handleEdit(value: any) {
        this.id = value.id;
        this.form = {
            id: value.id,
            zh_cn_title: value.zh_cn_title, //
            en_title: value.en_title,
            icon: value.icon,
            status: value.status,
            sort: value.sort,
            type: value.type,
        };
        this.formDialogVisible = true;
    }



    // 重置搜索
    reset(): void {
        Object.keys(this.searchObj).map((key) => {
            this.$set(this.searchObj, key, "");
        });
        this.getLists();
    }

    // 添加


    //

    onSubmit(formzh_cn_title: string) {
        // 验证表单格式是否正确
        const refs = this.$refs[formzh_cn_title] as HTMLFormElement;
        refs.validate((valid: boolean): any => {
            if (!valid) return;

            if (!this.id) {
                apiAiMenuAdd(this.form).then((res: any) => {
                    this.$message({
                        message: "添加成功",
                        type: "success",
                    });
                    this.getLists();
                });
            } else {
                apiAiMenuEdit(this.form).then((res: any) => {
                    this.$message({
                        message: "编辑成功",
                        type: "success",
                    });
                    this.getLists();
                });
            }
            this.formDialogVisible = false;
        });
    }

    /** E Methods **/

    /** S ods **/
    created() {
        this.getLists();
    }
}
